var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"abort-action"},[_c('button',{staticClass:"button is-warning",on:{"click":function($event){return _vm.$emit('onAbort')}}},[_vm._v("\n    Abort\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }